import { useState } from 'react';
import { faqs } from '@/mocks/gallery';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="relative w-full scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-sm font-medium uppercase tracking-widest text-secondary-400">FAQ</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-50 md:text-4xl">常见问题</h2>
          <p className="mt-3 text-sm text-foreground-300 md:text-base">关于下载、更新与投稿，这里都有答案。</p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200/60"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-base font-semibold text-foreground-50">{item.q}</span>
                  <span
                    className={`flex h-7 w-7 flex-none items-center justify-center rounded-full bg-background-200/70 text-foreground-200 transition-transform ${
                      open ? 'rotate-180' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                {open && (
                  <div className="border-t border-background-200/60 px-5 py-4 text-sm leading-relaxed text-foreground-300">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}